import React from 'react'
import {
  CheckIcon,
  ChevronRightIcon,
  Dialog,
  DialogContent,
  Grid,
  styledComponent,
  Typography,
  Box,
  useTheme
} from '@hermes/web-components'
import { Filter } from '../../SearchPage/Default/SearchBar/SearchFilters'
import useTranslateMessage from '../../../hooks/useTranslateMessage'
import { TEST_IDS } from '../../../__tests__/testUtils/constants'

interface MobileSearchModalProps {
  isOpen: boolean
  onClose: () => void
  filter: Filter
  changeFilter: (key: string, value: string | number | boolean) => void
}

const mainColor = 'primary.main'

const StyledDialog = styledComponent(Dialog)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    '& .MuiDialog-paper': {
      margin: 0,
      width: '100%',
      height: '100%',
      borderRadius: 0,
      maxHeight: 'none'
    },
    '& .MuiDialogContent-root': {
      width: '100%'
    }
  }
}))

const MobileFilterDetailsModal = ({ isOpen, onClose, filter, changeFilter }: MobileSearchModalProps) => {
  const theme = useTheme()
  const translate = useTranslateMessage()
  const onChangeFilter = (value: string | number) => () => {
    if (filter.onChangeFilter) {
      filter.onChangeFilter(value)
    } else {
      changeFilter(filter.name, value)
    }
    onClose()
  }
  return (
    <StyledDialog open={isOpen} onClose={onClose} maxWidth="lg">
      <DialogContent
        data-testid={TEST_IDS.FILTER_MODAL_ACTIVE_FILTER_MODAL}
        sx={{ px: 2, pt: 3.3, width: '100vw', backgroundColor: 'white.100', position: 'relative' }}
      >
        <Grid
          data-testid={TEST_IDS.FILTER_MODAL_ACTIVE_FILTER_MODAL_CLOSE_BUTTON}
          onClick={onClose}
          width="max-content"
          alignItems="center"
          justifyContent="center"
          container
        >
          <ChevronRightIcon color="primary" sx={{ transform: 'rotate(180deg)' }} />
          <Typography variant="body1" color={theme.custom?.SearchFilters?.mobile?.textColor}>
            {translate('back')}
          </Typography>
        </Grid>
        <Typography mt={2} variant="h4" fontWeight="400">
          {filter.label}
        </Typography>
        <Box sx={{ mt: 1, ml: 2 }}>
          {filter.resetOption && (
            <Box
              key={`${filter.name}empty`}
              sx={{ py: 1 }}
              onClick={onChangeFilter(filter.resetOption.value)}
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Typography variant="body1" textTransform="capitalize">
                {filter.resetOption.label}
              </Typography>
              {filter.value === '' && <CheckIcon sx={{ width: 15, color: mainColor, mr: 2 }} />}
            </Box>
          )}
          {filter.options.map((option) => (
            <Box
              key={option.value}
              sx={{ py: 1 }}
              onClick={onChangeFilter(option.value)}
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Typography
                variant="body1"
                textTransform="capitalize"
                color={filter.value === option.value ? mainColor : 'common: black'}
              >
                {option.label}
              </Typography>
              {filter.value === option.value && <CheckIcon sx={{ width: 15, color: mainColor, mr: 2 }} />}
            </Box>
          ))}
        </Box>
      </DialogContent>
    </StyledDialog>
  )
}

export default MobileFilterDetailsModal
